(() => {
  let pending = false;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-janak-cart-add]');
    if (!button) {
      const oldStatus = event.target.closest('.scd__wrapper')?.querySelector('[data-janak-cart-status]');
      if (oldStatus && !pending) oldStatus.textContent = '';
      return;
    }
    event.preventDefault();
    if (pending || button.disabled) return;
    const drawer = button.closest('.scd__wrapper');
    const status = drawer.querySelector('[data-janak-cart-status]');
    const setStatus = (key, text) => { status.textContent = text || status.dataset[key]; };
    pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setStatus('adding');
    let confirmed = false;
    try {
      const response = await fetch(button.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.variantId, quantity: 1 }] })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => null);
        setStatus('error', typeof error?.description === 'string' ? error.description : '');
        return;
      }
      confirmed = true;
      const cart = window.MinimogTheme?.Cart;
      if (!cart?.refreshCart || !cart?.renderNewCart) {
        window.location.assign(button.dataset.cartUrl);
        return;
      }
      await cart.refreshCart();
      await cart.renderNewCart();
      await window.Shopify.onCartUpdate(cart.cart, false);
      setStatus('added');
      drawer.querySelector('[data-janak-cart-heading]')?.focus();
    } catch (error) {
      if (confirmed) window.location.assign(button.dataset.cartUrl);
      else setStatus('uncertain');
    } finally {
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
